import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/AddCircle";

import ActionModal from "../../modals/action-modal";

const ArrayField = ({
  field,
  onSubmit,
  setValue,
  value,
  innerRef,
  onRevert,
  setEdit,
  rowIndex,
  columnIndex,
  nextRow,
  prevRow,
  nextColumn,
  prevColumn,
  onChange,
  onClose,
}) => {
  const [fields, setFields] = useState(value);

  const handleAddNew = () => setFields(fields => fields.concat(""));

  const handleRemove = selectedIndex =>
    setFields(fields => fields.filter((v, index) => selectedIndex !== index));

  const updateField = (index, value) => {
    setFields(fields => [...fields.slice(0, index), value, ...fields.slice(index + 1)]);
  };

  const handleSubmit = () => {
    onSubmit(fields);
    if (nextRow) {
      nextRow();
    }
  };

  return (
    <ActionModal open maxWidth={460} onClose={onClose} title={field.label} disableTransition>
      <Grid container spacing={2}>
        {fields.map((v, index) => (
          <Grid key={index} size={12}>
            <Box display="flex" alignItems="center">
              <Grid container spacing={1}>
                <Grid size={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name={`${field.name}.${index}`}
                    label={field.label}
                    value={fields[index]}
                    onChange={event => updateField(index, event.target.value)}
                  />
                </Grid>
              </Grid>

              {fields.length > 1 && (
                <IconButton
                  aria-label="delete"
                  variant="outlined"
                  onClick={() => handleRemove(index)}
                  sx={{ p: 1, mr: -1 }}
                >
                  <DeleteIcon color="action" />
                </IconButton>
              )}
            </Box>
          </Grid>
        ))}

        <Grid container justifyContent="center" size={12}>
          <Box display="flex" justifyContent="center">
            <IconButton onClick={handleAddNew}>
              <AddIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>

      <Box mb={3} />

      <Box display="flex" gap={1} justifyContent="flex-end">
        <Button variant="outlined" color="primary" onClick={onClose}>
          Close
        </Button>

        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Box>
    </ActionModal>
  );
};

export default React.memo(ArrayField);
